import React, { useState, useEffect } from 'react';

import { useModal } from '@/contexts/ModalContext';
import ScoreInputModal from '@/components/scoreboard/ScoreInputModal';

interface ScoreCardProps {
  isEdit: boolean;
  propsTeam1: string | undefined;
  propsTeam2: string | undefined;
  propsTeam1FirstHalfScore: number | undefined;
  propsTeam2FirstHalfScore: number | undefined;
  propsTeam1SecondHalfScore: number | undefined;
  propsTeam2SecondHalfScore: number | undefined;
  propsTeam1ExtraFirstHalfScore: number | undefined;
  propsTeam2ExtraFirstHalfScore: number | undefined;
  propsTeam1ExtraSecondHalfScore: number | undefined;
  propsTeam2ExtraSecondHalfScore: number | undefined;
  propsTeam1PKScore: number | undefined;
  propsTeam2PKScore: number | undefined;
  onInputTeam1?: (value: string) => void;
  onInputTeam2?: (value: string) => void;
  onChangeTeam1FirstHalfScore?: (value: number | undefined) => void;
  onChangeTeam2FirstHalfScore?: (value: number | undefined) => void;
  onChangeTeam1SecondHalfScore?: (value: number | undefined) => void;
  onChangeTeam2SecondHalfScore?: (value: number | undefined) => void;
  onChangeTeam1ExFirstScore?: (value: number | undefined) => void;
  onChangeTeam2ExFirstScore?: (value: number | undefined) => void;
  onChangeTeam1ExSecondScore?: (value: number | undefined) => void;
  onChangeTeam2ExSecondScore?: (value: number | undefined) => void;
  onChangeTeam1PKScore?: (value: number | undefined) => void;
  onChangeTeam2PKScore?: (value: number | undefined) => void;
}

const ScoreCard: React.FC<ScoreCardProps> = ({
  isEdit,
  propsTeam1,
  propsTeam2,
  propsTeam1FirstHalfScore,
  propsTeam2FirstHalfScore,
  propsTeam1SecondHalfScore,
  propsTeam2SecondHalfScore,
  propsTeam1ExtraFirstHalfScore,
  propsTeam2ExtraFirstHalfScore,
  propsTeam1ExtraSecondHalfScore,
  propsTeam2ExtraSecondHalfScore,
  propsTeam1PKScore,
  propsTeam2PKScore,
  onInputTeam1,
  onInputTeam2,
  onChangeTeam1FirstHalfScore,
  onChangeTeam2FirstHalfScore,
  onChangeTeam1SecondHalfScore,
  onChangeTeam2SecondHalfScore,
  onChangeTeam1ExFirstScore,
  onChangeTeam2ExFirstScore,
  onChangeTeam1ExSecondScore,
  onChangeTeam2ExSecondScore,
  onChangeTeam1PKScore,
  onChangeTeam2PKScore
}) => {
  /**
   * React Context
   */
  // モーダル
  const { openModal, closeModal } = useModal();

  /**
   * useState
   */
  const [team1, setTeam1] = useState<string | undefined>(undefined);
  const [team2, setTeam2] = useState<string | undefined>(undefined);
  const [team1FirstHalfScore, setTeam1FirstHalfScore] = useState<number | undefined>(undefined);
  const [team2FirstHalfScore, setTeam2FirstHalfScore] = useState<number | undefined>(undefined);
  const [team1SecondHalfScore, setTeam1SecondHalfScore] = useState<number | undefined>(undefined);
  const [team2SecondHalfScore, setTeam2SecondHalfScore] = useState<number | undefined>(undefined);
  const [team1ExtraFirstHalfScore, setTeam1ExtraFirstHalfScore] = useState<number | undefined>(undefined);
  const [team2ExtraFirstHalfScore, setTeam2ExtraFirstHalfScore] = useState<number | undefined>(undefined);
  const [team1ExtraSecondHalfScore, setTeam1ExtraSecondHalfScore] = useState<number | undefined>(undefined);
  const [team2ExtraSecondHalfScore, setTeam2ExtraSecondHalfScore] = useState<number | undefined>(undefined);
  const [team1PKScore, setTeam1PKScore] = useState<number | undefined>(undefined);
  const [team2PKScore, setTeam2PKScore] = useState<number | undefined>(undefined);

  const handleSetTeam1 = (value: string) => {
    setTeam1(value);
    onInputTeam1 && onInputTeam1(value);
  };

  const handleSetTeam2 = (value: string) => {
    setTeam2(value);
    onInputTeam2 && onInputTeam2(value);
  };

  const handleSetTeam1FirstHalfScore = (value: number | undefined) => {
    setTeam1FirstHalfScore(value);
    onChangeTeam1FirstHalfScore && onChangeTeam1FirstHalfScore(value);
  };

  const handleSetTeam2FirstHalfScore = (value: number | undefined) => {
    setTeam2FirstHalfScore(value);
    onChangeTeam2FirstHalfScore && onChangeTeam2FirstHalfScore(value);
  };

  const handleSetTeam1SecondHalfScore = (value: number | undefined) => {
    setTeam1SecondHalfScore(value);
    onChangeTeam1SecondHalfScore && onChangeTeam1SecondHalfScore(value);
  };

  const handleSetTeam2SecondHalfScore = (value: number | undefined) => {
    setTeam2SecondHalfScore(value);
    onChangeTeam2SecondHalfScore && onChangeTeam2SecondHalfScore(value);
  };

  const handleSetTeam1ExtraFirstHalfScore = (value: number | undefined) => {
    setTeam1ExtraFirstHalfScore(value);
    onChangeTeam1ExFirstScore && onChangeTeam1ExFirstScore(value);
  };

  const handleSetTeam2ExtraFirstHalfScore = (value: number | undefined) => {
    setTeam2ExtraFirstHalfScore(value);
    onChangeTeam2ExFirstScore && onChangeTeam2ExFirstScore(value);
  };

  const handleSetTeam1ExtraSecondHalfScore = (value: number | undefined) => {
    setTeam1ExtraSecondHalfScore(value);
    onChangeTeam1ExSecondScore && onChangeTeam1ExSecondScore(value);
  };

  const handleSetTeam2ExtraSecondHalfScore = (value: number | undefined) => {
    setTeam2ExtraSecondHalfScore(value);
    onChangeTeam2ExSecondScore && onChangeTeam2ExSecondScore(value);
  };

  const handleSetTeam1PKScore = (value: number | undefined) => {
    setTeam1PKScore(value);
    onChangeTeam1PKScore && onChangeTeam1PKScore(value);
  };

  const handleSetTeam2PKScore = (value: number | undefined) => {
    setTeam2PKScore(value);
    onChangeTeam2PKScore && onChangeTeam2PKScore(value);
  };

  // チーム名表示ヘルパー関数
  const fitDisplay = (team: string | undefined) => {
    if (!team) return <div className="text-gray-400 italic">Team</div>;
    // 16文字を超える場合は省略
    const displayTeam = team.length > 16 ? team.slice(0, 15) + '...' : team;

    // 文字数に応じてテキストサイズのクラスを設定
    const textSizeClass = team.length <= 5 ? 'text-base' : 'text-xs';

    return <div className={textSizeClass}>{displayTeam}</div>;
  };

  // スコア合計
  const getTotal = (first: number | undefined, second: number | undefined) => {
    if (first === undefined && second === undefined) return '';
    return (first || 0) + (second || 0);
  };

  // 延長戦スコアがあるかどうか
  const hasExtraScore = () => {
    return (
      team1ExtraFirstHalfScore !== undefined ||
      team2ExtraFirstHalfScore !== undefined ||
      team1ExtraSecondHalfScore !== undefined ||
      team2ExtraSecondHalfScore !== undefined
    );
  };

  // PKスコアがあるかどうか
  const hasPKScore = () => {
    return (
      (team1PKScore !== undefined && team1PKScore !== null) || (team2PKScore !== undefined && team2PKScore !== null)
    );
  };

  useEffect(() => {
    setTeam1(propsTeam1);
  }, [propsTeam1]);

  useEffect(() => {
    setTeam2(propsTeam2);
  }, [propsTeam2]);

  useEffect(() => {
    setTeam1FirstHalfScore(propsTeam1FirstHalfScore);
  }, [propsTeam1FirstHalfScore]);

  useEffect(() => {
    setTeam2FirstHalfScore(propsTeam2FirstHalfScore);
  }, [propsTeam2FirstHalfScore]);

  useEffect(() => {
    setTeam1SecondHalfScore(propsTeam1SecondHalfScore);
  }, [propsTeam1SecondHalfScore]);

  useEffect(() => {
    setTeam2SecondHalfScore(propsTeam2SecondHalfScore);
  }, [propsTeam2SecondHalfScore]);

  useEffect(() => {
    setTeam1ExtraFirstHalfScore(propsTeam1ExtraFirstHalfScore);
  }, [propsTeam1ExtraFirstHalfScore]);

  useEffect(() => {
    setTeam2ExtraFirstHalfScore(propsTeam2ExtraFirstHalfScore);
  }, [propsTeam2ExtraFirstHalfScore]);

  useEffect(() => {
    setTeam1ExtraSecondHalfScore(propsTeam1ExtraSecondHalfScore);
  }, [propsTeam1ExtraSecondHalfScore]);

  useEffect(() => {
    setTeam2ExtraSecondHalfScore(propsTeam2ExtraSecondHalfScore);
  }, [propsTeam2ExtraSecondHalfScore]);

  useEffect(() => {
    setTeam1PKScore(propsTeam1PKScore);
  }, [propsTeam1PKScore]);

  useEffect(() => {
    setTeam2PKScore(propsTeam2PKScore);
  }, [propsTeam2PKScore]);

  return (
    <>
      <div
        className={`
          relative
          ${isEdit ? 'bg-gray-200 hover:bg-gray-300 shadow' : 'bg-gray-200 hover:bg-gray-300 shadow'}
          text-gray-900 rounded-lg ps-4 pe-10 py-4 w-60 h-32 cursor-pointer bg-no-repeat bg-right
        `}
        style={{ backgroundImage: "url('/images/soccerball_gray.svg')", backgroundSize: '130%', width: '100%' }}
        onClick={() =>
          openModal(
            <ScoreInputModal
              isEdit={isEdit}
              propsTeam1={team1}
              propsTeam2={team2}
              propsTeam1FirstHalfScore={team1FirstHalfScore}
              propsTeam2FirstHalfScore={team2FirstHalfScore}
              propsTeam1SecondHalfScore={team1SecondHalfScore}
              propsTeam2SecondHalfScore={team2SecondHalfScore}
              propsTeam1ExtraFirstHalfScore={team1ExtraFirstHalfScore}
              propsTeam2ExtraFirstHalfScore={team2ExtraFirstHalfScore}
              propsTeam1ExtraSecondHalfScore={team1ExtraSecondHalfScore}
              propsTeam2ExtraSecondHalfScore={team2ExtraSecondHalfScore}
              propsTeam1PKScore={team1PKScore}
              propsTeam2PKScore={team2PKScore}
              onInputTeam1={handleSetTeam1}
              onInputTeam2={handleSetTeam2}
              onChangeTeam1FirstHalfScore={handleSetTeam1FirstHalfScore}
              onChangeTeam2FirstHalfScore={handleSetTeam2FirstHalfScore}
              onChangeTeam1SecondHalfScore={handleSetTeam1SecondHalfScore}
              onChangeTeam2SecondHalfScore={handleSetTeam2SecondHalfScore}
              onChangeTeam1ExFirstScore={handleSetTeam1ExtraFirstHalfScore}
              onChangeTeam2ExFirstScore={handleSetTeam2ExtraFirstHalfScore}
              onChangeTeam1ExSecondScore={handleSetTeam1ExtraSecondHalfScore}
              onChangeTeam2ExSecondScore={handleSetTeam2ExtraSecondHalfScore}
              onChangeTeam1PKScore={handleSetTeam1PKScore}
              onChangeTeam2PKScore={handleSetTeam2PKScore}
              closeModal={closeModal}
            />
          )
        }>
        <div className="absolute top-2 left-2 flex space-x-1">
          {hasExtraScore() && (
            <div className="w-fit font-footballlog border border-gray-400 px-1 rounded text-xs text-gray-400">Ex</div>
          )}
          {hasPKScore() && (
            <div className="w-fit font-footballlog border border-gray-400 px-1 rounded text-xs text-gray-400">PK</div>
          )}
        </div>
        <div className="flex justify-between items-center mb-1">
          <div className="w-24 flex space-x-1"></div>
          <div className="font-footballlog text-gray-500 text-xs font-medium">1st</div>
          <div className="font-footballlog text-gray-500 text-xs font-medium">2nd</div>
          <div className="font-footballlog text-gray-500 text-xs font-bold">Total</div>
        </div>
        <div className="space-y-2">
          <div className="flex justify-between items-center space-x-1">
            <div className="text-center w-24">{fitDisplay(team1)}</div>
            <div className="font-footballlog text-xl font-base w-6 h-9 min-h-9 py-2 text-center bg-gray-300 rounded-sm">
              {team1FirstHalfScore}
            </div>
            <div className="font-footballlog text-xl font-base w-6 h-9 min-h-9 py-2 text-center bg-gray-300 rounded-sm">
              {team1SecondHalfScore}
            </div>
            <div className="font-footballlog text-xl font-bold w-6 h-9 min-h-9 py-2 text-center bg-gray-300 rounded-sm">
              {getTotal(team1FirstHalfScore, team1SecondHalfScore)}
            </div>
          </div>
          <div className="flex justify-between items-center">
            <div className="text-center w-24">{fitDisplay(team2)}</div>
            <div className="font-footballlog text-xl font-base w-6 h-9 min-h-9 py-2 text-center bg-gray-300 rounded-sm">
              {team2FirstHalfScore}
            </div>
            <div className="font-footballlog text-xl font-base w-6 h-9 min-h-9 py-2 text-center bg-gray-300 rounded-sm">
              {team2SecondHalfScore}
            </div>
            <div className="font-footballlog text-xl font-bold w-6 h-9 min-h-9 py-2 text-center bg-gray-300 rounded-sm">
              {getTotal(team2FirstHalfScore, team2SecondHalfScore)}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ScoreCard;
